import { z } from 'zod/v4';

const carrierEnablementBaseSchema = z.object({
  from: z.date().nullish(),
  to: z.date().nullish(),
});

export function buildCarrierEnablementSchema(startBeforeEndMsg: string): typeof carrierEnablementBaseSchema {
  return carrierEnablementBaseSchema.refine(
    (data) => {
      if (data.from && data.to) return data.from < data.to;
      return true;
    },
    {
      message: startBeforeEndMsg,
      path: ['from'],
    },
  );
}

export type CarrierEnablementFormInput = z.infer<typeof carrierEnablementBaseSchema>;
